module.exports = __webpack_public_path__ + "static/media/facebook.9eb27848.svg";